import {
    ref, computed, onMounted, onBeforeUnmount
} from 'vue';

export function useMatchMode(facetId: string, emitChange: (data: { matchMode?: string }) => void) {
    const matchMode = ref<'any' | 'all'>('any');
    const showMatchModeDropdown = ref(false);

    const shouldShowMatchMode = computed(() => {
        // Show only for tags and business roles
        return facetId === 'tags' || facetId === 'businessRoles';
    });

    const toggleMatchModeDropdown = () => {
        showMatchModeDropdown.value = !showMatchModeDropdown.value;
    };

    const selectMatchMode = (mode: 'any' | 'all') => {
        matchMode.value = mode;
        showMatchModeDropdown.value = false;
        emitChange({ matchMode: mode });
    };

    const handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (!target.closest('.match-mode-wrapper')) {
            showMatchModeDropdown.value = false;
        }
    };

    onMounted(() => {
        document.addEventListener('click', handleClickOutside);
    });

    onBeforeUnmount(() => {
        document.removeEventListener('click', handleClickOutside);
    });

    return {
        matchMode,
        showMatchModeDropdown,
        shouldShowMatchMode,
        toggleMatchModeDropdown,
        selectMatchMode
    };
}